class ProductRecommendations extends window.HTMLElement {
  connectedCallback() {
    const dataUrl = this.dataset.url;
    const dataLayout = this.dataset.layout;
    const dataUrlParams = new URLSearchParams(dataUrl);
    let excludedProductList, firstItem, firstItemId;

    if (!dataUrlParams.get("product_id")) {
      excludedProductList =
        document.querySelector("cart-drawer").dataset.excluded;
      firstItem = document.querySelector("#CartDrawer-Item-1");
      firstItemId = "";
      if (!firstItem) {
        firstItemId = this.dataset.fallbackId;
      } else {
        firstItemId = firstItem.dataset.productId;
      }
      let url = this.dataset.url.split("product_id=");
      this.dataset.url =
        url[0] + "product_id=" + firstItemId + "&" + url[1].split("&")[1];
    }

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        if (dataLayout === "small-card") {
          this.handleSmallCardLayout(text);
          return;
        }

        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          if (
            !dataUrlParams.get("product_id") &&
            excludedProductList.includes(firstItemId)
          ) {
            document.querySelector("._rec-list").classList.add("hidden");
            document.querySelector("._static-list").classList.remove("hidden");
          }

          const toggleColorDropwdown = () => {
            document
              .querySelector("[data-color-overlay]")
              .classList.toggle("hidden");
            document
              .getElementById("CartScrollBox")
              .classList.toggle("overflow-y-scroll");
            document
              .getElementById("CartScrollBox")
              .classList.toggle("overflow-y-hidden");
          };

          const toggleSizeDropwdown = () => {
            document
              .querySelector("[data-size-overlay]")
              .classList.toggle("hidden");
            document
              .getElementById("CartScrollBox")
              .classList.toggle("overflow-y-scroll");
            document
              .getElementById("CartScrollBox")
              .classList.toggle("overflow-y-hidden");
          };

          const openSizeList = (list) => {
            toggleSizeDropwdown();
            let sizeList = list.parentElement.querySelector("[data-size-list]");

            sizeList.classList.toggle("opacity-100");
            sizeList.classList.toggle("max-h-max");
            sizeList.classList.toggle("z-100");
            sizeList.classList.toggle("!p-0");
          };

          const openColorList = (list) => {
            toggleColorDropwdown();
            let colorList =
              list.parentElement.querySelector("[data-color-list]");

            colorList.classList.toggle("opacity-100");
            colorList.classList.toggle("max-h-40");
            colorList.classList.toggle("z-100");
            colorList.classList.toggle("!p-0");
          };

          document
            .querySelector("[data-size-overlay]")
            .addEventListener("click", () => {
              let list = document.querySelector(".z-100[data-size-list]");
              list.classList.toggle("opacity-100");
              list.classList.toggle("max-h-max");
              list.classList.toggle("z-100");
              list.classList.toggle("!p-0");
              document
                .querySelector("[data-size-overlay]")
                .classList.toggle("hidden");
              document
                .getElementById("CartScrollBox")
                .classList.add("overflow-y-scroll");
              document
                .getElementById("CartScrollBox")
                .classList.remove("overflow-y-hidden");
            });

          document
            .querySelector("[data-color-overlay]")
            .addEventListener("click", () => {
              let list = document.querySelector(".z-100[data-color-list]");
              list.classList.toggle("opacity-100");
              list.classList.toggle("max-h-40");
              list.classList.toggle("z-100");
              list.classList.toggle("!p-0");
              document
                .querySelector("[data-color-overlay]")
                .classList.toggle("hidden");
              document
                .getElementById("CartScrollBox")
                .classList.add("overflow-y-scroll");
              document
                .getElementById("CartScrollBox")
                .classList.remove("overflow-y-hidden");
            });

          const selectSizeOption = (option) => {
            this.querySelectorAll("[data-size-option]").forEach((node) => {
              node.classList.remove("bg-black");
              node.classList.remove("bg-opacity-5");
            });

            option
              .closest("[data-variant-container]")
              .querySelector("[data-size] span").innerText =
              option.dataset.size;
            option
              .closest("[data-variant-container]")
              .querySelector("[data-form-product-id]").value =
              option.dataset.variantId;

            let sizeList = option
              .closest("[data-variant-container]")
              .querySelector("[data-size-list]");

            sizeList.classList.toggle("opacity-100");
            sizeList.classList.toggle("max-h-max");
            sizeList.classList.toggle("z-100");
            option.classList.add("bg-black");
            option.classList.add("bg-opacity-5");
          };

          const changeColorVariant = (option) => {
            let recommendationId = option.dataset.productHandle;
            let index = parseInt(option.closest("article").dataset.index) - 1;
            let dataIndex = index + 1;
            let isLast = option.closest("article").dataset.isLast;
            document
              .querySelector("[data-color-overlay]")
              .classList.add("hidden");
            document
              .getElementById("CartScrollBox")
              .classList.add("overflow-y-scroll");
            document
              .getElementById("CartScrollBox")
              .classList.remove("overflow-y-hidden");
            fetch(
              `/products/${option.dataset.productHandle}?sections=cart-recommendation-variants&data=3`,
            )
              .then((res) => res.json())
              .then((res) => {
                option.closest("article").outerHTML =
                  res["cart-recommendation-variants"];
              })
              .then(() => {
                attachFunctions(
                  this.querySelectorAll(`[data-product-recommendation]`)[index],
                );
                this.querySelectorAll(`[data-product-recommendation]`)[
                  index
                ].setAttribute("data-index", dataIndex);

                document
                  .querySelector("[data-color-overlay]")
                  .classList.add("hidden");
                document
                  .getElementById("CartScrollBox")
                  .classList.add("overflow-y-scroll");
                document
                  .getElementById("CartScrollBox")
                  .classList.remove("overflow-y-hidden");

                if (isLast == "true") {
                  this.querySelectorAll(`[data-product-recommendation]`)[
                    index
                  ].setAttribute("data-is-last", "true");
                  let element = this.querySelectorAll(
                    `[data-product-recommendation]`,
                  )[index];
                  element
                    .querySelector("[data-size-list]")
                    .classList.add("-translate-y-full");
                  element
                    .querySelector("[data-size-list]")
                    .classList.add("top-[-10px]");
                  element
                    .querySelector("[data-size-list]")
                    .classList.remove("bottom-[-10px]");
                  element
                    .querySelector("[data-size-list]")
                    .classList.remove("translate-y-full");
                  element
                    .querySelector("[data-color-list]")
                    .classList.add("-translate-y-full");
                  element
                    .querySelector("[data-color-list]")
                    .classList.add("top-[-10px]");
                  element
                    .querySelector("[data-color-list]")
                    .classList.remove("bottom-[-10px]");
                  element
                    .querySelector("[data-color-list]")
                    .classList.remove("translate-y-full");
                } else {
                }
              });
          };

          const addRecommnededProduct = () => {
            event.preventDefault();

            const data = Object.fromEntries(
              new FormData(event.target).entries(),
            );

            let target = event.target;

            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [data],
                sections: document
                  .querySelector("cart-drawer-items")
                  .getSectionsToRender()
                  .map((section) => section.section),
                sections_url: window.location.pathname,
              }),
            })
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                if (response.status) {
                  let toast = document.querySelector("toast-notification");
                  toast._img = toast.querySelector("img");
                  toast._title = toast.querySelector("._title");
                  toast
                    .querySelector("._title")
                    .classList.add("text-destructive");
                  toast.classList.add("!bg-destructive");
                  toast._atc = toast.querySelector("._atc");
                  toast
                    .querySelector("._atc")
                    .classList.add("text-destructive");
                  toast._img.src = target
                    .closest("li")
                    .querySelector("img").src;
                  toast._title.innerText = response.description;
                  toast._atc.innerText = response.message;
                  toast.classList.add("!-translate-y-[calc(100%+10rem)]");
                  toast.style.top = "full";
                  toast.querySelector("._error").classList.remove("hidden");
                  toast.querySelector("._success").classList.add("hidden");

                  setTimeout(() => {
                    toast.classList.remove("!-translate-y-[calc(100%+10rem)]");
                    toast.style.top = "";
                  }, 3000);

                  setTimeout(() => {
                    toast._atc.innerText = "Added to cart";
                    toast
                      .querySelector("._title")
                      .classList.remove("text-destructive");
                    toast.classList.remove("!bg-destructive");
                    toast
                      .querySelector("._atc")
                      .classList.remove("text-destructive");
                    toast.querySelector("._error").classList.add("hidden");
                    toast.querySelector("._success").classList.remove("hidden");
                  }, 3500);

                  return;
                }

                let toast = document.querySelector("toast-notification");
                let parentElement = target.closest("li");
                toast._img = toast.querySelector("img");
                toast._title = toast.querySelector("._title");
                toast._img.src = target.closest("li").querySelector("img").src;
                toast._title.innerText =
                  parentElement.querySelector("h3").innerText +
                  " | " +
                  parentElement.querySelector("._color").innerText +
                  " - " +
                  parentElement.querySelector("._size").innerText;
                toast.classList.add("!-translate-y-[calc(100%+10rem)]");
                toast.style.top = "full";

                setTimeout(() => {
                  toast.classList.remove("!-translate-y-[calc(100%+10rem)]");
                  toast.style.top = "";
                }, 3000);

                document
                  .getElementById("CartDrawer-CartItems")
                  .classList.remove("loading");

                document
                  .querySelector("cart-drawer-items")
                  .updateSections(response);
                return;
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          };

          const attachFunctions = (context) => {
            if (!context) {
              context = this;
            }

            context.querySelectorAll("[data-size]").forEach((node) => {
              node.addEventListener("click", () => openSizeList(node));
            });

            context.querySelectorAll("[data-color]").forEach((node) => {
              node.addEventListener("click", () => openColorList(node));
            });

            context.querySelectorAll("[data-size-option]").forEach((node) => {
              node.addEventListener("click", () => selectSizeOption(node));
            });

            context.querySelectorAll("[data-color-option]").forEach((node) => {
              node.addEventListener("click", () => changeColorVariant(node));
            });

            context.querySelectorAll("[data-rec-form]").forEach((node) => {
              node.addEventListener("submit", () => addRecommnededProduct());
            });
          };

          attachFunctions();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleSmallCardLayout = (htmlText) => {
    const html = document.createElement("div");
    html.innerHTML = htmlText;
    const doesSmallCardExist = Boolean(
      html.querySelector("[data-section='api-product-card-small']"),
    );
    if (doesSmallCardExist) {
      this.innerHTML = html.innerHTML;
    } else {
      this.remove();
    }
  };

  getRecommendations = () => {
    let excludedProductList =
      document.querySelector("cart-drawer").dataset.excluded;
    let firstItem = document.querySelector("#CartDrawer-Item-1");
    let firstItemId = "";
    if (!firstItem) {
      firstItemId = this.dataset.fallbackId;
    } else {
      firstItemId = firstItem.dataset.productId;
    }
    let url = this.dataset.url.split("product_id=");
    this.dataset.url =
      url[0] + "product_id=" + firstItemId + "&" + url[1].split("&")[1];

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          if (excludedProductList.includes(firstItemId)) {
            document.querySelector("._rec-list").classList.add("hidden");
            document.querySelector("._static-list").classList.remove("hidden");
          }

          const toggleColorDropwdown = () => {
            document
              .querySelector("[data-color-overlay]")
              .classList.toggle("hidden");
            document
              .getElementById("CartScrollBox")
              .classList.remove("overflow-y-scroll");
            document
              .getElementById("CartScrollBox")
              .classList.add("overflow-y-hidden");
          };

          const toggleSizeDropwdown = () => {
            document
              .querySelector("[data-size-overlay]")
              .classList.toggle("hidden");
            document
              .getElementById("CartScrollBox")
              .classList.remove("overflow-y-scroll");
            document
              .getElementById("CartScrollBox")
              .classList.add("overflow-y-hidden");
          };

          const openSizeList = (list) => {
            toggleSizeDropwdown();
            let sizeList = list.parentElement.querySelector("[data-size-list]");

            sizeList.classList.toggle("opacity-100");
            sizeList.classList.toggle("max-h-max");
            sizeList.classList.toggle("z-100");
          };

          const openColorList = (list) => {
            toggleColorDropwdown();
            let colorList =
              list.parentElement.querySelector("[data-color-list]");

            colorList.classList.toggle("opacity-100");
            colorList.classList.toggle("max-h-40");
            colorList.classList.toggle("z-100");
          };

          document
            .querySelector("[data-size-overlay]")
            .addEventListener("click", () => {
              let list = document.querySelector(".z-100[data-size-list]");
              list.classList.toggle("opacity-100");
              list.classList.toggle("max-h-max");
              list.classList.toggle("z-100");
              document
                .querySelector("[data-size-overlay]")
                .classList.toggle("hidden");
            });

          document
            .querySelector("[data-color-overlay]")
            .addEventListener("click", () => {
              let list = document.querySelector(".z-100[data-color-list]");
              list.classList.toggle("opacity-100");
              list.classList.toggle("max-h-40");
              list.classList.toggle("z-100");
              document
                .querySelector("[data-color-overlay]")
                .classList.toggle("hidden");
            });

          const selectSizeOption = (option) => {
            this.querySelectorAll("[data-size-option]").forEach((node) => {
              node.classList.remove("bg-black");
              node.classList.remove("bg-opacity-5");
            });

            option
              .closest("[data-variant-container]")
              .querySelector("[data-size] span").innerText =
              option.dataset.size;
            option
              .closest("[data-variant-container]")
              .querySelector("[data-form-product-id]").value =
              option.dataset.variantId;

            let sizeList = option
              .closest("[data-variant-container]")
              .querySelector("[data-size-list]");

            sizeList.classList.toggle("opacity-100");
            sizeList.classList.toggle("max-h-max");
            sizeList.classList.toggle("z-100");
            option.classList.add("bg-black");
            option.classList.add("bg-opacity-5");
          };

          const changeColorVariant = (option) => {
            let recommendationId = option.dataset.productHandle;
            let index = parseInt(option.closest("article").dataset.index) - 1;
            let dataIndex = index + 1;
            let isLast = option.closest("article").dataset.isLast;
            document
              .querySelector("[data-color-overlay]")
              .classList.add("hidden");
            document
              .getElementById("CartScrollBox")
              .classList.add("overflow-y-scroll");
            document
              .getElementById("CartScrollBox")
              .classList.remove("overflow-y-hidden");
            fetch(
              `/products/${option.dataset.productHandle}?sections=cart-recommendation-variants&data=3`,
            )
              .then((res) => res.json())
              .then((res) => {
                option.closest("article").outerHTML =
                  res["cart-recommendation-variants"];
              })
              .then(() => {
                attachFunctions(
                  this.querySelectorAll(`[data-product-recommendation]`)[index],
                );
                this.querySelectorAll(`[data-product-recommendation]`)[
                  index
                ].setAttribute("data-index", dataIndex);

                if (isLast == "true") {
                  this.querySelectorAll(`[data-product-recommendation]`)[
                    index
                  ].setAttribute("data-is-last", "true");
                  let element = this.querySelectorAll(
                    `[data-product-recommendation]`,
                  )[index];
                  element
                    .querySelector("[data-size-list]")
                    .classList.add("-translate-y-full");
                  element
                    .querySelector("[data-size-list]")
                    .classList.add("top-[-10px]");
                  element
                    .querySelector("[data-size-list]")
                    .classList.remove("bottom-[-10px]");
                  element
                    .querySelector("[data-size-list]")
                    .classList.remove("translate-y-full");
                  element
                    .querySelector("[data-color-list]")
                    .classList.add("-translate-y-full");
                  element
                    .querySelector("[data-color-list]")
                    .classList.add("top-[-10px]");
                  element
                    .querySelector("[data-color-list]")
                    .classList.remove("bottom-[-10px]");
                  element
                    .querySelector("[data-color-list]")
                    .classList.remove("translate-y-full");
                } else {
                }
              });
          };

          const addRecommnededProduct = () => {
            event.preventDefault();

            const data = Object.fromEntries(
              new FormData(event.target).entries(),
            );

            let target = event.target;

            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [data],
                sections: document
                  .querySelector("cart-drawer-items")
                  .getSectionsToRender()
                  .map((section) => section.section),
                sections_url: window.location.pathname,
              }),
            })
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                if (response.status) {
                  let toast = document.querySelector("toast-notification");
                  toast._img = toast.querySelector("img");
                  toast._title = toast.querySelector("._title");
                  toast
                    .querySelector("._title")
                    .classList.add("text-destructive");
                  toast._atc = toast.querySelector("._atc");
                  toast
                    .querySelector("._atc")
                    .classList.add("text-destructive");
                  toast.classList.add("bg-destructive");
                  toast._img.src = target
                    .closest("li")
                    .querySelector("img").src;
                  toast._title.innerText = response.description;
                  toast._atc.innerText = response.message;
                  toast.classList.add("!-translate-y-[calc(100%+10rem)]");
                  toast.style.top = "full";
                  toast.querySelector("._error").classList.remove("hidden");
                  toast.querySelector("._success").classList.add("hidden");

                  setTimeout(() => {
                    toast.classList.remove("!-translate-y-[calc(100%+10rem)]");
                    toast.style.top = "";
                  }, 3000);

                  setTimeout(() => {
                    toast._atc.innerText = "Added to cart";
                    toast
                      .querySelector("._title")
                      .classList.remove("text-destructive");
                    toast
                      .querySelector("._atc")
                      .classList.remove("text-destructive");
                    toast.querySelector("._error").classList.add("hidden");
                    toast.classList.remove("bg-destructive");
                    toast.querySelector("._success").classList.remove("hidden");
                  }, 3500);

                  return;
                }

                let toast = document.querySelector("toast-notification");
                let parentElement = target.closest("li");
                toast._img = toast.querySelector("img");
                toast._title = toast.querySelector("._title");
                toast._img.src = target.closest("li").querySelector("img").src;
                toast._title.innerText =
                  parentElement.querySelector("h3").innerText +
                  " | " +
                  parentElement.querySelector("._color").innerText +
                  " - " +
                  parentElement.querySelector("._size").innerText;
                toast.classList.add("!-translate-y-[calc(100%+10rem)]");
                toast.style.top = "full";

                setTimeout(() => {
                  toast.classList.remove("!-translate-y-[calc(100%+10rem)]");
                  toast.style.top = "";
                }, 3000);

                document
                  .getElementById("CartDrawer-CartItems")
                  .classList.remove("loading");

                document
                  .querySelector("cart-drawer-items")
                  .updateSections(response);
                return;
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          };

          const attachFunctions = (context) => {
            if (!context) {
              context = this;
            }

            context.querySelectorAll("[data-size]").forEach((node) => {
              node.addEventListener("click", () => openSizeList(node));
            });

            context.querySelectorAll("[data-color]").forEach((node) => {
              node.addEventListener("click", () => openColorList(node));
            });

            context.querySelectorAll("[data-size-option]").forEach((node) => {
              node.addEventListener("click", () => selectSizeOption(node));
            });

            context.querySelectorAll("[data-color-option]").forEach((node) => {
              node.addEventListener("click", () => changeColorVariant(node));
            });

            context.querySelectorAll("[data-rec-form]").forEach((node) => {
              node.addEventListener("submit", () => addRecommnededProduct());
            });
          };

          attachFunctions();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };
}

window.customElements.define("product-recommendations", ProductRecommendations);
